<template>
  <div class="browse-container">
    <TopPanel>我的浏览记录</TopPanel>
    <div
      class="browse-wrap"
      v-for="(firstItem, firstIndex) in browseList"
      :key="firstIndex"
    >
      <div class="date-wrap">
        <div class="data-title">
          {{ dayjs(firstItem[0].lastViewTime).format('YYYY-MM-DD') }}
        </div>
        <div
          class="record-wrap"
          v-for="(item, index) in firstItem"
          :key="index"
        >
          <ul class="jinNang-list" v-if="item.targetType === 1">
            <li
              class="list-item"
              @click="goto(`/jinNang/${item.detail.jinNangId}`)"
            >
              <div class="item-left">
                <div class="rate-title">总收益</div>
                <div
                  class="rate-value"
                  :class="[getSymbol(item.detail.glYield) > 0 ? 'c1' : 'c3']"
                >
                  {{ item.detail.glYield }}
                </div>
              </div>
              <div class="item-line"></div>
              <div class="item-right">
                <div class="title">{{ item.detail.title }}</div>
                <div class="subtitle">{{ item.detail.summary }}</div>
                <!-- <div class="sub-item" v-if="true">
                  <span class="name">{{item.detail.authorName}}</span>
                  <span>{{item.detail.authorTitle}} | {{item.detail.authorCompany}}</span>
                </div>-->
                <div class="sub-item">
                  <span>剩余{{ item.detail.leftServiceNum }}份</span>
                </div>
              </div>
              <div class="tag">
                <div class="tag-item">胜率:{{ item.detail.selwinidx }}</div>
                <div class="tag-item">
                  最大回撤率:{{ item.detail.maxdrawidx }}
                </div>
              </div>
              <div class="sale">
                <div class="price">¥{{ item.detail.price }}/月</div>
                <div class="buybtn">购买</div>
              </div>
            </li>
          </ul>

          <ul class="jinNang-list" v-if="item.targetType === 2">
            <li class="course" v-if="item.targetType === 2">
              <router-link
                class="cover-img"
                :style="{ backgroundImage: `url(${item.detail.coverImagUrl})` }"
                :to="`/course/${item.detail.setId}`"
              ></router-link>
              <div class="course-right">
                <router-link class="title" :to="`/course/${item.detail.setId}`">
                  {{ item.detail.title }}
                </router-link>
                <div class="count">
                  更新至第{{ item.detail.courseCount }}节 | 已售{{
                    item.detail.saledCount
                  }}份
                </div>
                <div>
                  <span class="price">￥{{ item.detail.price }}/套</span>
                  <span class="original-price"
                    >原价￥{{ item.detail.originalPrice }}</span
                  >
                  <!-- <el-button
                    v-if="showButton"
                    class="button-buy"
                    @click="buyCourse"
                  >购买</el-button>-->
                </div>
              </div>
            </li>
          </ul>

          <ul class="dianjin-list" v-if="item.targetType === 3">
            <li class="dianjin">
              <div class="dianjin-inline">
                <router-link
                  class="dianjin-pic"
                  :style="{
                    backgroundImage: `url(${item.detail.dianJinInfo.coverImageUrl})`
                  }"
                  :to="`/dianjin/${item.detail.dianJinInfo.id}`"
                >
                  <div
                    v-show="item.detail.dianJinInfo.type == 1"
                    class="dianjin-play-icon"
                  ></div>
                </router-link>
                <div class="dianjin-right">
                  <div class="title-all">
                    <router-link
                      class="dianjin-title"
                      :to="`/dianjin/${item.detail.id}`"
                      >{{
                        item.detail.authorInfo.name +
                          ' : ' +
                          item.detail.dianJinInfo.title
                      }}</router-link
                    >
                    <div
                      class="lock-icon"
                      v-if="
                        !item.detail.dianJinInfo.isFree &&
                          !hasRight(item.detail.dianJinInfo.productId)
                      "
                    ></div>
                    <div
                      class="unlock-icon"
                      v-if="
                        !item.detail.dianJinInfo.isFree &&
                          hasRight(item.detail.dianJinInfo.productId)
                      "
                    ></div>
                  </div>
                  <!-- <div class="dianjin-author" v-if="showAuthor">
                    <router-link
                      class="head"
                      :style="{
                backgroundImage: `url(${item.detail.headPic})`
              }"
                      :to="`/author/${item.detail.authorId}`"
                    ></router-link>
                    <div class="author-name">{{ item.detail.name }}</div>
                    <div class="author-type-company">
                      {{ item.detail.typeName }} |
                      {{ item.detail.authorCompany }}
                    </div>
                  </div>-->
                  <div class="dianjin-date">
                    {{ item.detail.dianJinInfo.publishTimeDesc }}
                  </div>
                  <router-link
                    class="dianjin-comment"
                    :to="`/dianjin/${item.detail.dianJinInfo.id}`"
                  >
                    <div class="comment-icon"></div>
                    <div class="comment-number">
                      {{ item.detail.dianJinInfo.commentsCount }}
                    </div>
                  </router-link>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="more" v-show="!pageEnd" @click="getViewHistoryFun()">
      点击查看更多
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import TopPanel from '@/components/Mine/TopPanel'
import { getViewHistory } from '@/api/mine'
import dayjs from 'dayjs'

export default {
  name: 'MyBrowse',
  components: { TopPanel },
  data() {
    return {
      viewState: '',
      pageEnd: false,
      browseList: []
    }
  },
  computed: {
    userDianJinRights() {
      return this.$store.state.right.allRightList == null
        ? null
        : this.$store.state.right.allRightList.filter(
            item => item.rightType === 4
          )
    }
  },
  created() {
    this.getViewHistoryFun()
  },
  methods: {
    dayjs,
    async getViewHistoryFun() {
      const data = {
        direction: this.viewState ? 2 : 0,
        pageSize: 10
      }
      const res = await getViewHistory(data, this.viewState)
      console.log(res)
      if (res && res.detail.list && res.detail.list.length > 0) {
        this.viewState = res.result.viewState
        this.pageEnd = res.detail.end
        const list = res.detail.list

        // 处理按时间分类
        let firstTime = dayjs(list[0].lastViewTime).format('YYYYMMDD')
        let firstArr = []
        const length = list.length - 1
        list.forEach((item, index) => {
          let lastViewTime = dayjs(item.lastViewTime).format('YYYYMMDD')
          console.log(lastViewTime)
          console.log(index)
          console.log(length)
          if (firstTime === lastViewTime && index < length) {
            firstArr.push(item)
          } else {
            this.browseList.push(firstArr)
            firstTime = lastViewTime
            firstArr = []
            firstArr.push(item)
          }
        })
        // if (res.detail.flush) {
        //   this.browseList = list
        // } else {
        //   this.browseList = this.browseList.concat(list)
        // }
      }
    },
    hasRight(id) {
      return this.userDianJinRights == null
        ? false
        : this.userDianJinRights.filter(e => e.productId === id).length > 0
    },
    goto(router) {
      console.log(router)
      this.$router.push(router)
    },
    getSymbol(number) {
      const dig = parseFloat(number)
      return dig
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  display: flex;
  align-items: center;
  height: 160px;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
  &:hover {
    background-color: #fafafa;
  }
  position: relative;
  .item-left {
    flex-direction: column;
    justify-content: center;
    display: flex;
    flex: none;
    flex-basis: 160px;
  }

  .item-line {
    width: 1px;
    height: 126px;
    background-color: #ebebeb;
  }

  .item-right {
    flex: auto;
    display: flex;
    justify-content: left;
    flex-direction: column;
  }

  .rate-title {
    margin-bottom: 11px;
    font-size: 20px;
    letter-spacing: 1px;
    color: #262626;
    text-align: center;
  }

  .rate-value {
    font-size: 24px;
    letter-spacing: 1px;
    text-align: center;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #262626;
    transition: color 0.3s;
    cursor: pointer;
    text-decoration: none;
    &:hover {
      color: #046bcc;
    }
    margin-left: 30px;
    margin-bottom: 20px;
  }

  .subtitle {
    margin-left: 30px;
    margin-bottom: 20px;
    font-size: 16px;
    letter-spacing: 1px;
    color: #858585;
  }

  .sub-item {
    margin-left: 30px;
    margin-bottom: 20px;
    font-size: 14px;
    letter-spacing: 1px;
    color: #858585;
  }

  .name {
    margin-right: 20px;
  }

  .tag {
    display: flex;
    position: absolute;
    top: 32px;
    right: 0;
  }

  .tag-item {
    height: 22px;
    background-color: #f0f0f0;
    border-radius: 2px;
    text-align: center;
    font-size: 12px;
    line-height: 22px;
    letter-spacing: 1px;
    cursor: pointer;
    flex: none;
    margin-left: 20px;
    padding: 0 15px;
    color: #858585;
  }

  .sale {
    display: flex;
    position: absolute;
    bottom: 40px;
    right: 0;
  }

  .price {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 1px;
    color: #e64c2e;
  }

  .buybtn {
    height: 30px;
    border-radius: 2px;
    text-align: center;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 1px;
    cursor: pointer;
    flex: none;
    margin-left: 20px;
    padding: 0px 28px;
    background-color: #e64c2e;
    color: #ffffff;
  }
}
.course {
  display: flex;
  align-items: center;
  height: 160px;
  position: relative;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
  transition: background-color 0.3s linear;

  &:hover {
    background-color: #fafafa;
  }

  .cover-img {
    width: 160px;
    height: 120px;
    background: no-repeat center;
    background-size: cover;
  }

  .title {
    font-size: 20px;
    line-height: 40px;
    color: #262626;
    transition: color 0.3s;
    text-decoration: none;

    &:hover {
      color: #046bcc;
    }
  }

  .count {
    font-size: 16px;
    line-height: 40px;
    letter-spacing: 1px;
    color: #858585;
  }

  .course-right {
    padding-left: 20px;
  }

  .price {
    font-size: 20px;
    line-height: 40px;
    color: #e64c2e;
  }

  .original-price {
    position: relative;
    font-size: 14px;
    color: #858585;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      height: 1px;
      background-color: #858585;
    }
  }
  .button-buy {
    width: 90px;
    position: absolute;
    line-height: 30px;
    margin-left: 20px;
    right: 10px;
    background-color: #e64c2e;
    border-radius: 2px;
    font-size: 16px;
    color: #ffffff;
    padding: 0;
    border: none;
  }
}
.dianjin-list {
  display: flex;
  flex-direction: column;
  .dianjin {
    height: 160px;
  }
  .dianjin-inline {
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: row;
    position: relative;
  }
  .dianjin-pic {
    width: 160px;
    height: 120px;
    background: no-repeat center;
    background-size: cover;
    cursor: pointer;
  }
  .dianjin-right {
    margin-left: 20px;
    flex: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    align-content: space-between;
  }
  .dianjin-title {
    font-size: 20px;
    line-height: 40px;
    font-weight: normal;
    font-stretch: normal;
    color: #262626;
    transition: color 0.3s;
    cursor: pointer;
    text-decoration: none;
  }

  .dianjin-date {
    position: absolute;
    bottom: 9px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 1px;
    color: #858585;
  }
  .dianjin-comment {
    display: flex;
    position: absolute;
    bottom: 9px;
    right: 5px;
    text-decoration: none;
    align-items: center;
  }
  .dianjin-author {
    display: flex;
    flex-direction: row;
    margin-top: 5px;
  }

  .head {
    width: 24px;
    height: 24px;
    background: no-repeat center;
    background-size: cover;
    border-radius: 50%;
    cursor: pointer;
  }

  .author-name {
    padding-left: 10px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 25px;
    letter-spacing: 1px;
    color: #858585;
  }
  .author-type-company {
    padding-left: 15px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 25px;
    letter-spacing: 1px;
    color: #858585;
  }

  .comment-icon {
    width: 16px;
    height: 14px;
    background: url('~@/assets/images/author/comment_icon.png') no-repeat center;
    background-size: 100%;
    margin: 3px 5px 0 0;
  }

  .dianjin-play-icon {
    width: 80px;
    height: 80px;
    position: absolute;
    left: 45px;
    top: 37px;
    background: url('~@/assets/images/dianjin/dianjin-list-icon.png') no-repeat
      center;
  }

  .lock-icon {
    width: 17px;
    height: 20px;
    display: inline-block;
    background: url('~@/assets/images/icons/lock.png') no-repeat center;
    background-size: cover;
    margin-left: 10px;
  }

  .unlock-icon {
    width: 17px;
    height: 20px;
    display: inline-block;
    background: url('~@/assets/images/icons/unlock.png') no-repeat center;
    background-size: cover;
    margin-left: 10px;
  }
  .comment-number {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 1px;
    color: #858585;
  }

  .more {
    width: 828px;
    height: 40px;
    margin: 30px auto;
    font-size: 14px;
    line-height: 40px;
    color: #858585;
    background-color: #fafafa;
    text-align: center;
    cursor: pointer;
  }
}
.record-wrap {
  padding: 0 20px;
}
.browse-wrap {
  margin: 30px 30px 0;
  padding-bottom: 30px;
  border: solid 1px #ebebeb;

  .data-title {
    height: 40px;
    line-height: 40px;
    background-color: #f0f0f0;
    font-size: 14px;
    color: #858585;
    padding: 0 20px;
  }
}
.browse-container {
  width: 828px;
  // height: 1225px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  margin-left: 30px;
  margin-top: 0px;
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
}
.more {
  width: 100%;
  height: 40px;
  margin: 30px auto 0;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}
</style>
